import CustomButton from "components/CustomButton/CustomButton";
import ListIcon from "icons/ListIcon";

const StudentListButton = ({
	goToListStudentReservationView
}) => {
	return (
		<CustomButton 
			width="100%"
			icon={<ListIcon/>} 
			variant="secondary"
			text="Listado de alumnos"
			onClick={goToListStudentReservationView}/>
	);
}

export default StudentListButton;